<template>
  <div class="dialog-wrap">
    <div class="dialog-detail">
      <div class="tips-wrap">
        <h1>{{ tipData.title }}</h1>
        <p class="tips-detail">{{ tipData.content }}</p>
        <div class="btn-wrap">
          <div class="cancel" @click="close">取消</div>
          <div class="submit" @click="submitTips">确定</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tipData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {};
  },

  methods: {
    close() {
      this.$emit('close');
    },

    submitTips() {
      const num = this.tipData.num
      this.$emit('submitTips', num);
    }
  }
};
</script>

<style lang="scss" scoped>
.dialog-wrap {
	display: flex;
	align-items: center;
	justify-content: center;
	position: fixed;
	z-index: 9;
	top: 0;
	left: 0;
	bottom: 0;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.5);
	.dialog-detail {
		position: relative;
		width: 600px;
		box-sizing: border-box;
		background: #ffffff;
		box-shadow: 0px 13px 7px 0px rgba(0, 0, 0, 0.06);
		.tips-wrap {
			padding: 30px;
			h1 {
				padding: 10px;
				text-align: center;
				@include font-style;
				font-size: 20px;
				color: #000000;
			}
			.tips-detail {
				margin: 30px 0;
				line-height: 28px;
				@include font-style;
				font-size: 16px;
				color: #666;
			}
			//弹框按钮
			.btn-wrap {
				display: flex;
				align-items: center;
				justify-content: center;
				box-sizing: border-box;
				.submit {
					@include cursor-style;
					width: 80px;
					height: 36px;
					line-height: 36px;
					box-sizing: border-box;
					text-align: center;
					background: #ff8e1c;
					box-shadow: 1px 3px 6px 0px rgba(102, 102, 102, 0.16);
					border-radius: 5px;
					font-size: 15px;
					font-family: Microsoft YaHei;
					font-weight: bold;
					color: #ffffff;
				}
				.cancel {
					@include cursor-style;
					@extend .submit;
					font-weight: 400;
					background: #ffffff;
					border: 1px solid #9a9a9a;
					color: #9a9a9a;
					margin-right: 20px;
				}
			}
		}
	}
}
</style>
